import { INPAGE_SIDEBAR_IFRAME_WINDOW_NAME } from 'ContentEditorUI/lib/app/constants';
export const getSidebarIframeWindow = () => {
  const inpageIframeWindow = window;
  const sidebarIframeWindow =
  // @ts-ignore window object is weird
  inpageIframeWindow.parent.frames[INPAGE_SIDEBAR_IFRAME_WINDOW_NAME].window;
  return sidebarIframeWindow;
};